import CertidoesCRCService from '@/services/CertidoesCRCService'
import CustasService from "@/services/Registros/CustasService"

export async function cumprirPedidos (pedido) {
  try {
    const res =  { data: pedido.numPedidoPossueCertidaoEletronica }
    const pedidoData = pedido
    const ordemServicoSelected = pedido.numPedidoPossueOrdemServico
    const emolumentos = await trataEmolumentosQuandoOsTemItemZerado (ordemServicoSelected)

    const resultadoEnvio = await CertidoesCRCService.enviarPedido(
      res,
      pedidoData,
      emolumentos,
      ordemServicoSelected
    )
    displayMessage('info', resultadoEnvio.data)

    window.open(res.data.link_assinatura)
  } catch (error) {
    console.log('Error', error)
    displayMessage('error', 'Erro ao cumprir o pedido.', 'Tente novamente mais tarde.')
  }
}

async function trataEmolumentosQuandoOsTemItemZerado (ordemServicoSelected) {
  // Verifica se ordemServicoSelected está definido e não vazio
  if (Object.keys(ordemServicoSelected).length > 0 ) {
    const os = ordemServicoSelected // Atribui ordemServicoSelected a uma variável para facilitar o acesso

    // Verifica se há itens na ordem de serviço selecionada e se algum deles tem valor zerado
    const itemOsSelecionado = Object.values(os.itens).find(itemOS => itemOS.valor === 0)

    if (itemOsSelecionado) {
      // Se houver um item com valor zerado, zera os emolumentos
      const emolumentos = os.itens[0].custa.itens.map(item => ({destino: item.destino, valor: 'R$ 0,00'}))
      emolumentos.push({destino: 'Total', valor: 'R$ 0,00'}) 
      return emolumentos

    } else {
      const emolumentos = []
      let custaAverbacao = null

      // Caso exista algum item com averbacao buscamos a custa para distribuir durante o calculo
      let itemComAverbacao = os.itens.find(item => item.averbacao > 0)
      if (!!itemComAverbacao) {
        custaAverbacao = await CustasService.getCustaAverbacaoById(itemComAverbacao.custa.custa_info_iss_id)
      }

      // Calcula os emolumentos se nenhum item estiver zerado
      Object.values(os.itens).forEach(item => {
        item.custa.itens.forEach(custaItem => {
          const index = emolumentos.findIndex(emolumento => emolumento.destino === custaItem.destino)
          if (index === -1 && item.averbacao > 0 && !!custaAverbacao) {
            // Para itens com averbacao
            let destinatarioAverbacao = custaAverbacao.itens.find((itemAverbacao) => itemAverbacao.destino == custaItem.destino)
            emolumentos.push({
              destino: custaItem.destino,
              valor: +(custaItem.valor + (item.averbacao * destinatarioAverbacao.valor))
            })
          } 
          else if (index === -1) {
            // Para itens sem averbacao
            emolumentos.push({
              destino: custaItem.destino,
              valor: +custaItem.valor
            })
          }
          else {
            emolumentos[index].valor += +custaItem.valor
          }
        })
      })

      // Converte os valores para Reais
      emolumentos.forEach(emolumento => emolumento.valor = centsToReal(emolumento.valor))

      // Adiciona o total dos emolumentos
      const valorTotalEmolumentos = centsToReal(os.valor_total)
      emolumentos.push({
        destino: 'Total',
        valor: valorTotalEmolumentos
      })

      return emolumentos
    }
  }
}

function centsToReal (cents) {
  return (cents / 100).toLocaleString("pt-BR", {style: "currency", currency: "brl"})
}
